export class WtpReviewType {
  description: string;
  name: string;
  wtpReviewTypeId: number;
}
